import { render, staticRenderFns } from "./squats.vue?vue&type=template&id=3ebc3d01&scoped=true&"
import script from "./squats.vue?vue&type=script&lang=js&"
export * from "./squats.vue?vue&type=script&lang=js&"
import style0 from "./squats.vue?vue&type=style&index=0&id=3ebc3d01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc3d01",
  null
  
)

export default component.exports